import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { post, session, setUnauthorizedHandler } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [state, setState] = useState(() => session.load());

  const logout = useCallback(() => { session.clear(); setState(null); }, []);
  useEffect(() => { setUnauthorizedHandler(logout); }, [logout]);

  const login = useCallback(async (body) => {
    const d = await post("/auth/login", body);
    const s = { token: d.access_token, user: d.user, entrepriseId: null };
    session.save(s); setState(s);
    return d.user;
  }, []);

  const setEntrepriseId = useCallback((id) => {
    setState((prev) => { const s = { ...prev, entrepriseId: id }; session.save(s); return s; });
  }, []);

  const value = useMemo(() => ({
    user: state?.user || null, token: state?.token || null,
    entrepriseId: state?.entrepriseId || null, isDemo: !!state?.user?.demo,
    login, logout, setEntrepriseId,
  }), [state, login, logout, setEntrepriseId]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
